import type { ReactNode } from 'react';

export const symbol_carpenter: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M615-99q-8 8-19 12.5T573-82q-12 0-23.5-4.5T530-99l-79-78q-8-8-12.5-18t-5.5-21q-1-11 2.5-21t10.5-20l16-21-339-479 143-143 533 532q9 9 13.5 20t4.5 22q0 11-4.5 22.5T799-283L615-99ZM506-320l126-127-366-368-65 65 305 430Zm66 179 185-185-81-80-184 185 80 80Zm-66-179 126-127-126 127Z"
		/>
	</svg>
);
